import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {translate} from "react-i18next"
import * as basicLightbox from "basiclightbox"
import "@splidejs/splide/dist/js/splide"

import "basiclightbox/dist/basicLightbox.min.css"
import "./styles.css"
import "../Button/styles.css"
import "@splidejs/splide/dist/css/splide.min.css"

// export default class RemoteContent extends Component {
class RemoteContent extends Component {
  state = {
    showSidebar: false
  }
  static propTypes = {
    className: PropTypes.string
  }

  static defaultProps = {
    className: "wp-content"
  }

  initLightbox() {
    document.querySelectorAll("a.image__link").forEach(function(elem) {
      const href = elem.getAttribute("href")
      const instance = basicLightbox.create(`<img src="${href}">`, {
        beforeShow: instance => {
          let closer = instance.element().querySelector("#close")
          let imgcontainer = instance
            .element()
            .querySelector(".basicLightbox__placeholder")
          imgcontainer.appendChild(closer)
          closer.onclick = e => {
            instance.close()
          }
        },
        beforePlaceholder:
          '<button id="close" class="icon icon-quiz-fail-box"></button>'
      })
      elem.onclick = function(e) {
        e.preventDefault()
        instance.show()
      }
    })
  }

  initAccordion() {
    let toggler = document.querySelectorAll(".accordion__panel-heading")
    ;[].forEach.call(toggler, function(el) {
      el.onclick = function(e) {
        if (e.target && e.target.nodeName === "H3") {
          if (e.target.classList.contains("active")) {
            e.target.classList.remove("active")
          } else {
            for (var i = 0; i < toggler.length; i++) {
              toggler[i].classList.remove("active")
            }
            e.target.classList.add("active")
          }
        }
      }
    })
  }

  initFlipcards() {
    const flipcards = document.querySelectorAll(".flipcard")

    flipcards.forEach(f => {
      if (f.classList.contains("flipcard--no-flip")) return

      f.addEventListener("click", () => {
        f.querySelector(".flipcard__inner").classList.toggle("active")
      })
    })
  }

  initQuestionAnswer() {
    const qas = document.querySelectorAll(".question-answer")

    qas.forEach(qa => {
      // check if content element has already been initialized
      // so it won't add additional event listeners
      if (!qa.classList.contains("initialized")) {
        qa.classList.add("initialized")
        const answers = qa.querySelector(".question-answer__list").children
        const correctAnswersCount = parseInt(qa.dataset.answersCorrect, 10)

        // make answers clickable
        Array.prototype.forEach.call(answers, a => {
          a.addEventListener("click", () => {
            if (a.classList.contains("active")) {
              a.classList.remove("active")
            } else {
              // single choice
              if (correctAnswersCount === 1) {
                Array.prototype.forEach.call(answers, a =>
                  a.classList.remove("active")
                )
              }

              a.classList.add("active")
            }
          })
        })

        // check button
        qa.querySelector(".question-answer__button").addEventListener(
          "click",
          () => {
            const checkedAnswers = qa.querySelectorAll("li.active")

            if (checkedAnswers.length > 0) {
              qa.classList.add("finished")
              const errors = []

              // add classes to each checked answer and collect errors
              Array.prototype.forEach.call(checkedAnswers, ca => {
                if (ca.dataset.correct === "1") {
                  ca.classList.add("correct")
                } else {
                  ca.classList.add("wrong")
                  errors.push(ca)
                }
              })

              // mark answers that should be correct
              Array.prototype.forEach.call(qa.querySelectorAll("li"), a => {
                if (
                  a.dataset.correct === "1" &&
                  !a.classList.contains("correct")
                ) {
                  a.classList.add("should-be-correct")
                }
              })
            }
          }
        )
      }
    })
  }

  detectBrokenImages() {
    const images = this.content.querySelectorAll("img")

    Array.prototype.forEach.call(images, img => {
      if (!img.classList.contains("loaded")) {
        img.classList.add("loaded")

        // on fetch error, replace the image with a fallback image
        img.addEventListener("error", err => {
          err.target.classList.add("broken-image")

          err.target.src = "/image-broken.png"
          err.target.alt = `${err.target.alt} – Could not be loaded`
          err.target.srcset = ""
          err.target.sizes = ""
          err.target.width = 360
          err.target.height = 360
        })
      }
    })
  }

  detectBrokenVideos() {
    const videos = this.content.querySelectorAll("video")

    Array.prototype.forEach.call(videos, v => {
      if (!v.classList.contains("loaded")) {
        v.classList.add("loaded")

        // on fetch error, replace poster with a fallback image
        v.addEventListener(
          "error",
          _err => {
            v.poster = "/video-broken.png"
          },
          true
        )
      }
    })
  }

  initGallery() {
    const Splide = window.Splide // can't import ESM because of minify fail
    const galleries = document.querySelectorAll(".gallery")

    Array.prototype.forEach.call(galleries, g => {
      if (g.classList.contains("initialized")) return

      // prevent multiple instance
      g.classList.add("initialized")

      const primaryNode = g.querySelector(".gallery--primary")
      const thumbnailsNode = g.querySelector(".gallery--thumbnails")
      const indexNode = g.querySelector(".gallery__index")

      // primary
      const primarySlider = new Splide(primaryNode, {
        rewind: true,
        type: "fade",
        heightRatio: 0.74,
        pagination: false,
        arrows: true,
        cover: false
      })

      // thumbnail navigation
      const thumbnailSlider = new Splide(thumbnailsNode, {
        rewind: true,
        fixedWidth: 100,
        fixedHeight: 74,
        isNavigation: true,
        gap: 10,
        focus: "center",
        pagination: false,
        arrows: false,
        cover: true,
        updateOnMove: true
      })

      // set number of slides in index node
      primarySlider.on("mounted", () => {
        indexNode.querySelector(
          ".gallery__index-total"
        ).innerText = primaryNode.querySelectorAll(".splide__slide").length
      })

      // update current slide number in index node
      primarySlider.on("move", newIndex => {
        indexNode.querySelector(".gallery__index-current").innerText =
          newIndex + 1
      })

      // mount sliders
      primarySlider.mount()
      thumbnailSlider.mount()

      // sync both sliders
      primarySlider.sync(thumbnailSlider).mount()
    })
  }

  componentDidMount() {
    this.initLightbox()
    this.initAccordion()
    this.initFlipcards()
    this.initQuestionAnswer()
    this.detectBrokenImages()
    this.detectBrokenVideos()
    this.initGallery()
  }

  componentDidUpdate() {
    this.initLightbox()
    this.initAccordion()
    this.initFlipcards()
    this.initQuestionAnswer()
    this.detectBrokenImages()
    this.detectBrokenVideos()

    this.initGallery()
  }

  shouldComponentUpdate() {
    return true
  }

  componentWillReceiveProps() {
    this.initAccordion()
  }

  render() {
    return (
      <div>
        <div
          className={this.props.className}
          dangerouslySetInnerHTML={{__html: this.props.children}}
          ref={elem => (this.content = elem)}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

RemoteContent = connect(mapStateToProps)(RemoteContent)
export default translate()(RemoteContent)



// WEBPACK FOOTER //
// ./src/components/RemoteContent/index.js